import _ from "underscore"
import TemplateView from "../../TemplateView"
import {connect} from "../../redux/utils"
import {getShownColumnsWithOrder, getSummaryRow} from './selectors'
import {getCustomFieldsFilters, getIntersectedCPSelection, getRecentlyCreatedTaskIds, getTaskCustomFieldsMap, getTaskNameFilter, getTaskStatusFilter, getViewMode, isShowOnlyManageableTasks} from '../common/selectors'
import {PRIORITY_FIELD_NAME, TaskManagementViewMode, TaskTableConfigurableColumns} from '../constants'
import {isBTYEnabled, isESTEnabled} from '../../features/selectors'
import {isSummaryRowLoaded } from '../tasksTable/selectors'
import UserTime from '../../user_time'
import { bindActionCreators } from "redux"
import { updateSummaryRow } from "./actions"
import { isTasksLoaded } from "../taskSelection/selectors"
import ClassicBridge from '../../next/ClassicBridge'
import { importTasksSuccessEvent } from '../syncCallbacks'

const TOTAL_TASKS = 'TOTAL_TASKS'
const STATUS = 'STATUS'
const DEBOUNCE_UPDATE_DELAY = 500

const STATIC_COLUMNS = new Set([TOTAL_TASKS, STATUS])
const EMPTY_PLACEHOLDER = '--'

const TASK_UPDATE_EVENTS = [
    "taskManagement_tasksMovedTo",
    "taskManagement_taskUpdated",
    "taskManagement_removeTasks",
    "editTaskPanel_updateTask",
    importTasksSuccessEvent
]

const COLUMNS_CLASSNAME_MAP = {
    [TOTAL_TASKS]: "totalTasks",
    [STATUS]: "statusFiller",
    [TaskTableConfigurableColumns.ESTIMATE]: "totalEstimate",
    [TaskTableConfigurableColumns.DEADLINE]:"deadlineFiller",
    [TaskTableConfigurableColumns.CREATION_DATE]: "creationDateFiller",
    [TaskTableConfigurableColumns.LAST_TRACKING_DATE]: "lastTrackingDateFiller",
    [TaskTableConfigurableColumns.SPENT_TIME]: "totalSpentTime",
    [TaskTableConfigurableColumns.TYPE_OF_WORK]: "typeOfWorkFiller",
    [TaskTableConfigurableColumns.VARIANCE_MAN_HOURS]: "totalVarianceManHours",
    [TaskTableConfigurableColumns.VARIANCE_PERCENTS]: "totalVariancePercent",
    [TaskTableConfigurableColumns.VARIANCE_PROGRESS_BAR]: "varianceProgressBarFiller",
}

class SummaryRow extends TemplateView {
    constructor({
        update,
    }) {
        super()

        this.state = {
            columnsOrder: [],
            customFields: {},
            isBTYEnabled: null,
            isTWSEnabled: null,
            isLoaded: false,
            tasksLoaded: false,
            isNeedToReloadTableTasks: false,
            recentlyCreatedTaskIds: {},
            isShown: false,
            viewMode: TaskManagementViewMode.TABLE,
            customFieldsFilters: {},
            taskStatusFilter: {
                allSelected: false,
                statusIds: [],
                statusTypes: [],
            },
            summaryRow: {},
        }
        this.actions = {
            update
        }

        this.onStatePropertyDeeplyChanged('customFields', (customFields) => {
            this._clearCustomFieldsColumns()
            this._renderCustomFieldsColumns(customFields)
        })

        this.onStatePropertyChanged('columnsOrder', (columnsOrder) => {
            for (let column of Object.keys(COLUMNS_CLASSNAME_MAP)) {
                if (this._isStaticField(column)) continue

                const columnEl = this._findByKey(column)
                columnEl.hide()
            }

            for (let i = 0; i < columnsOrder.length; ++i) {
                const column = columnsOrder[i]
                const columnEl = this._findByKey(column)

                columnEl.show().css('display', 'flex')
                columnEl.css('order', i.toString())
            }
        })

        this.onStatePropertyChanged('isBTYEnabled', (isBTYEnabled) => {
            this._toggleColumn(TaskTableConfigurableColumns.TYPE_OF_WORK, isBTYEnabled)
        })

        this.onStatePropertyChanged('isESTEnabled', (isESTEnabled) => {
            this._toggleColumn(TaskTableConfigurableColumns.ESTIMATE, isESTEnabled)
            this._toggleColumn(TaskTableConfigurableColumns.VARIANCE_MAN_HOURS, isESTEnabled)
            this._toggleColumn(TaskTableConfigurableColumns.VARIANCE_PERCENTS, isESTEnabled)
            this._toggleColumn(TaskTableConfigurableColumns.VARIANCE_PROGRESS_BAR, isESTEnabled)
        })

        this.onStatePropertyChanged('isLoaded', () => {
            if (this.state.isLoaded) {
                this._setColumnTextValue(TOTAL_TASKS, this._totalTasks())
                this._setColumnTextValue(TaskTableConfigurableColumns.ESTIMATE, this._totalEstimate())
                this._setColumnTextValue(TaskTableConfigurableColumns.SPENT_TIME, this._totalSpentTime())
                this._setColumnTextValue(TaskTableConfigurableColumns.VARIANCE_MAN_HOURS, this._totalVarianceManHours())
                this._setColumnTextValue(TaskTableConfigurableColumns.VARIANCE_PERCENTS, this._totalVariancePercent())
            } else {
                this._renderLoadingState()
            }
            this._updateColumnsStyle()
        })

        this._debounceUpdateIfVisible = _.debounce(() => this._updateIfVisible(), DEBOUNCE_UPDATE_DELAY)

        this._subscribeToUpdateEvents()
    }

    _subscribeToUpdateEvents() {
        TASK_UPDATE_EVENTS.forEach((event) => {
            $(document).on(event, this._debounceUpdateIfVisible)
        })

        this.onAnyStatePropertyDeeplyChanged([
            'recentlyCreatedTaskIds',
            'viewMode',
            'taskNameFilter',
            'cpSelection',
            'showOnlyManagableTasks',
            'taskStatusFilter',
            'customFieldsFilters',
            'isShown'
        ], this._debounceUpdateIfVisible)
    }

    _updateIfVisible() {
        if (this._isVisible()) {
            this.actions.update()
        }
    }

    _isVisible() {
        return this.state.isShown && this.state.viewMode === TaskManagementViewMode.TABLE
    }

    _clearCustomFieldsColumns() {
        Object.keys(COLUMNS_CLASSNAME_MAP)
              .filter(column => ClassicBridge.isCustomField(column))
              .forEach(cf => this._clearColumn(cf))
    }

    _clearColumn(column) {
        const columnEl = this._findByKey(column)
        columnEl.remove()
        COLUMNS_CLASSNAME_MAP[column] = null
    }

    _toggleColumn(column, value) {
        const columnEl = this._findByKey(column)
        columnEl.toggle(value)
    }

    _setColumnTextValue(column, value) {
        const textEl = this._findByKey(column).find("span")
        textEl.text(value)
    }

    _updateColumnsStyle() {
        Object.keys(COLUMNS_CLASSNAME_MAP)
              .forEach(column => {
                  const columnValue = this._getColumnValueByKey(column)
                  const columnEl = this._findByKey(column)

                  this._updateEmptyStyle(columnValue, columnEl)
                  this._updateNegativeStyle(columnValue, columnEl)
              })
    }

    _updateEmptyStyle(columnValue, columnEl) {
        const isNotEmpty = _.isNumber(columnValue) && this.state.isLoaded
        columnEl.toggleClass('nonEmptyFiller', isNotEmpty)
    }

    _updateNegativeStyle(columnValue, columnEl) {
        const isNegative = (_.isNumber(columnValue) && columnValue < 0) && this.state.isLoaded
        columnEl.toggleClass('negativeFiller', isNegative)
    }

    _renderColumnValue(valueElement, className) {
        const valueCell = $(`<td class='${className}'>` +
          `  <div class='headerCellWrapper'></div>` +
          "</td>")

        valueCell
            .find(':last')
            .append(valueElement)

        valueCell.appendTo(this.$el)
    }

    _renderColumnTextValue(value, className) {
        const valueElement = $(`<span>${value}</span>`)
        this._renderColumnValue(valueElement, className)
    }

    _renderCustomFieldsColumns(customFields) {
        Object.values(customFields).forEach((customField) => {
            const column = customField.fieldName
            const className = `customFieldFiller ${column}`

            COLUMNS_CLASSNAME_MAP[customField.fieldName] = column

            this._renderColumnTextValue(EMPTY_PLACEHOLDER, className)
        })
    }

    _renderInitialColumns() {
        Object.values(COLUMNS_CLASSNAME_MAP)
              .forEach(className => {
                  this._renderColumnTextValue(EMPTY_PLACEHOLDER, className)
              })
    }

    _renderLoadingState() {
        Object.keys(COLUMNS_CLASSNAME_MAP)
              .forEach(column => {
                  this._setColumnTextValue(column, EMPTY_PLACEHOLDER)
              })
    }

    _totalTasks() {
        return messageResource.getMessage('task.list.header.totalTasks', [this.state.summaryRow.taskCount]);
    }

    _totalEstimate() {
        const estimate = this.state.summaryRow.estimate
        return _.isNumber(estimate) ? UserTime.formatTimeWithDigitSeparator(estimate) : EMPTY_PLACEHOLDER
    }

    _totalSpentTime() {
        return UserTime.formatTimeWithDigitSeparator(this.state.summaryRow.spentTime)
    }

    _totalVarianceManHours() {
        const variance = this.state.summaryRow.variance
        return (variance && _.isNumber(variance.duration)) ? UserTime.formatTimeWithDigitSeparator(variance.duration) : EMPTY_PLACEHOLDER
    }

    _totalVariancePercent() {
        const variance = this.state.summaryRow.variance
        return (variance && _.isNumber(variance.percentage)) ? ((Math.round(variance.percentage * 100) / 100).toFixed(1) + '%') : EMPTY_PLACEHOLDER
    }

    _findByKey(key) {
        return this.find(`.${COLUMNS_CLASSNAME_MAP[key]}`)
    }

    _getColumnValueByKey(key) {
        return {
            [TOTAL_TASKS]: this.state.summaryRow.taskCount,
            [TaskTableConfigurableColumns.ESTIMATE]: this.state.summaryRow.estimate,
            [TaskTableConfigurableColumns.SPENT_TIME]: this.state.summaryRow.spentTime,
            [TaskTableConfigurableColumns.VARIANCE_MAN_HOURS]: this.state.summaryRow.variance && this.state.summaryRow.variance.duration,
            [TaskTableConfigurableColumns.VARIANCE_PERCENTS]: this.state.summaryRow.variance && this.state.summaryRow.variance.percentage,
        }[key]
    }

    _isStaticField(column) {
        return STATIC_COLUMNS.has(column)
    }


    templateHtml() {
        return "<tr class='summary'></tr>"
    }

    toggle(value) {
        this.setState({ isShown: value })
        super.toggle(value)
    }

    afterRender() {
        this.$el.hide()

        this._renderInitialColumns()
        this._renderLoadingState()
        this.renderInitialState()
    }
}

export default connect(
    (state) => ({
        summaryRow: getSummaryRow(state),
        columnsOrder: getShownColumnsWithOrder(state),
        customFields: getTaskCustomFieldsMap(state),
        isBTYEnabled: isBTYEnabled(state),
        isESTEnabled: isESTEnabled(state),
        isLoaded: isSummaryRowLoaded(state),
        tasksLoaded: isTasksLoaded(state),
        recentlyCreatedTaskIds: getRecentlyCreatedTaskIds(state),
        viewMode: getViewMode(state),
        cpSelection: getIntersectedCPSelection(state),
        taskNameFilter: getTaskNameFilter(state),
        taskStatusFilter: getTaskStatusFilter(state),
        customFieldsFilters: getCustomFieldsFilters(state),
        showOnlyManagableTasks: isShowOnlyManageableTasks(state)
    }),
    (dispatch) => ({
        update: bindActionCreators(updateSummaryRow, dispatch)
    })
)(SummaryRow)



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/SummaryRow.js